var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconografia/18/youtube-18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconografia/18/youtube-18",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.56818182,12.1104032 L7.56818182,7.88959677 L11.2272727,10.0000806 L7.56818182,12.1104032 Z M15.7074318,6.56153226 C15.5464318,5.94685484 15.0720227,5.46282258 14.4697045,5.29854839 C13.3779432,5 9,5 9,5 C9,5 4.62205682,5 3.53029545,5.29854839 C2.92797727,5.46282258 2.45356818,5.94685484 2.29256818,6.56153226 C2,7.67556452 2,10 2,10 C2,10 2,12.3243548 2.29256818,13.4384677 C2.45356818,14.0531452 2.92797727,14.5371774 3.53029545,14.7015323 C4.62205682,15 9,15 9,15 C9,15 13.3779432,15 14.4697045,14.7015323 C15.0720227,14.5371774 15.5464318,14.0531452 15.7074318,13.4384677 C16,12.3243548 16,10 16,10 C16,10 16,7.67556452 15.7074318,6.56153226 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube18);
export default __webpack_public_path__ + "static/media/youtube-18.a501caddbd89281f19d9028a41e5d23e.svg";
export { ForwardRef as ReactComponent };